import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import routes from "../routes/route.js";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect } from "react";
import Provider, { AppContext } from "../utils/AppProvider";
import { useState } from "react";
import NotFound from "../common/NotFound";
import { logout } from "../services/AuthService";
import { toast } from "react-toastify";
import ConfirmationPopupModal from "../components/ConfirmationPopupModal";
import HeaderBottom from "../components/Header/HeaderBottom.jsx";
import { isLogin } from "../utils/constant.js";
import PopupModal from "../components/PopupModal/index.jsx";
// import SlimMessageModule from "../components/SlimMessageModule/SlimMessageModule.jsx";

let is_authenticated = "";
export let userId;


const Index = () => {
  const [flag, setFlag] = useState(0);
  const [yesClickedToggle, setyesClickedToggle] = useState(false);

  const [signOutPopup, setsignOutPopup] = useState(false);
  const [isMessage, setisMessage] = useState(false);
  // const { setIsAuthenticated } = useContext(AppContext);

  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  let widthOfPage = window?.innerWidth;
  let isSticky = widthOfPage < 1200;

  useEffect(() => {
    if (isLogin()) {
      const lastShown = localStorage.getItem("popupLastShown");
      const now = new Date().getTime();

      if (!lastShown || now - lastShown > 24 * 60 * 60 * 1000) {
        // If more than 24 hours have passed, show the popup
        setyesClickedToggle(true);
      }
    }
  }, [isLogin(), params]);

  useEffect(async () => {
    is_authenticated = await localStorage.getItem("is_authenticated");
    userId = localStorage.getItem("userId");

    let auth_url = [
      "/login",
      "/register",
      "/my-account/lost-password",
      "/create-account/:token",
      "/my-account/reset-password",
    ];
    let resetPassLink =
      location?.pathname?.split("/")[1] === "my-account" &&
      location?.pathname?.split("/")[2] === "reset-password";
    let redirect = location?.pathname?.split("/")[1] === "redirect";

    if (
      location?.pathname?.split("/")[1] === "create-account" ||
      resetPassLink ||
      redirect
    ) {
      // navigate(`/create-account/${location?.pathname?.split("/")[2]}`);
    } else {
      if (
        (is_authenticated == 0 ||
          is_authenticated == null ||
          is_authenticated == undefined) &&
        auth_url.includes(location.pathname)
      ) {
        navigate(location.pathname);
        return true;
      } else if (
        (is_authenticated == 0 ||
          is_authenticated == null ||
          is_authenticated == undefined) &&
        !auth_url.includes(location.pathname)
      ) {
        navigate("/login");
        return true;
      } else if (
        is_authenticated == 1 &&
        auth_url.includes(location.pathname)
      ) {
        navigate("/");
      }
    }
    return () => {};
  }, [location.pathname]);

  useEffect(() => {
    if (!isLogin()) {
      setisMessage(true);
    }
  }, []);

  const yesClicked = () => {
    const now = new Date().getTime();
    setyesClickedToggle(false);
    localStorage.setItem("popupLastShown", now);

    // localStorage.setItem("olderThanTwentyOne", true);
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    await logout()
      .then(() => {
        localStorage.removeItem("is_authenticated");
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("opening_balance");
        localStorage.removeItem("adjustment_balance");
        localStorage.clear();
        // setIsAuthenticated(0);
        setsignOutPopup(false);
        navigate("/login");
      })
      .catch((error) => {
        if (error?.response?.status == 422)
          toast(error.response.data.error, { type: "error" });
        else if (error?.response?.status == 500)
          toast(error.response.data.message, { type: "error" });
        else toast("Something went wrong", { type: "error" });
      });
  };

  return (
    <>
      <Provider>
        {/* {!isSticky && <SlimMessageModule />} */}
        <Header
          signOutClicked={() => {
            setsignOutPopup(true);
          }}
        />
        {/* {isSticky && <SlimMessageModule />} */}

        {/* <div className="header-area header-style-1 header-height-2">
          <HeaderBottom 
          // signOutClicked={signOutClicked} 
          />
        </div> */}
        <ConfirmationPopupModal
          title={"Confirmation Popup"}
          content={`Are you Sure you want to Sign out?`}
          show={signOutPopup}
          setShow={setsignOutPopup}
          confirmClicked={(e) => {
            handleLogout(e);
          }}
        />
        {yesClickedToggle && <PopupModal yesClicked={yesClicked} />}

        {/* <ConfirmationPopupModal
       
          show={isMessage}
          setShow={setisMessage}
          isAddress={true}
          confirmClicked={(e) => {
            setisMessage(false);
          }}
          isMessage={true}
          isOk={true}
        /> */}
        <Routes>
          {routes.map((route, i) => {
            if (location.pathname == route.path && route.private === true) {
              if (localStorage.getItem("is_authenticated")) {
                return (
                  <Route
                    exact
                    path={route.path}
                    key={i}
                    element={<route.page.component />}
                  >
                    {" "}
                  </Route>
                );
              }
            } else {
              return (
                <Route
                  exact
                  path={route.path}
                  key={i}
                  element={<route.page.component />}
                >
                  {" "}
                </Route>
              );
            }
          })}
          <Route path="*" element={<NotFound />}>
            {" "}
          </Route>
        </Routes>

        <Footer></Footer>
      </Provider>
    </>
  );
};

export default Index;
